type Props = {
  countryCode: string;
} & React.HTMLAttributes<HTMLSpanElement>;

const FlagIcon = ({ countryCode, className, ...other }: Props) => <span className={`fi fi-${countryCode} ${className}`} {...other}></span>;

export default FlagIcon;
